import React, { useMemo } from 'react';

import OpenElement from '../OpenElement/OpenElement';

import { StyledPayAllElementContent } from '../../atoms/UserPanelAllTrainerPay/StyledPayAllElementContent';
import { StyledFlexWrapper } from '../../atoms/UserPanelAllTrainerPay/StyledFlexWrapper';

const PayAllElement = ({ hours, trigger, showParentCheckboxes, refreshData }) => {
    const now = useMemo(() => new Date(), [hours]);

    const filteredHours = useMemo(() => {
        return Object.entries(hours).filter(([_, val]) => val && Object.keys(val).length > 0);
    }, [hours]);

    return (
        <StyledPayAllElementContent>
            <StyledFlexWrapper>
                {filteredHours.map(([key, val], index) => (
                    <OpenElement
                        key={key}
                        val={val}
                        keyElement={key}
                        defaultOpen={
                            key ===
                            `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
                        }
                        trigger2={trigger}
                        showParentCheckboxes={showParentCheckboxes}
                        firstElement={index === 0}
                        refreshData={refreshData}
                    />
                ))}
            </StyledFlexWrapper>
        </StyledPayAllElementContent>
    );
};

export default PayAllElement;
